// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/condition.php
import Rule from 'offline/filter/core/search/rule'

export default {
	name: 'collection.condition',
	priority: 80,
	require: function(config, filter) { return filter.collection && filter.collection.condition && filter.collection.condition.length > 0 },
	run: function(config, filter, data, query) {
		var keywords = Rule.getKeywords(filter.collection.condition)
		for (var i = 0; i < keywords.length; i++) {
			query.where('c.collection_condition_text', 'like', '%' + keywords[i] + '%')
		}
	}
}
